<template>
    <div>
        <v-container grid-list-md pt-0>
            <v-layout row wrap justify-start>
                <template v-for="team in teams">
                    <v-flex xs12 sm6 md6 lg4>
                        <v-card class="mb-2">
                            <v-card-title v-bind:style="setBackgroundColour(team)">
                                <div class="subheading font-weight-bold">{{ team.team }}</div>
                            </v-card-title>
                            <v-list dense>
                                <v-list-tile>
                                    <v-list-tile-content>Manager:</v-list-tile-content>
                                    <v-list-tile-content class="align-end">
                                        {{
                                        team.manager_name
                                        }}
                                    </v-list-tile-content>
                                </v-list-tile>
                                <v-list-tile>
                                    <v-list-tile-content>Email:</v-list-tile-content>
                                    <v-list-tile-content class="align-end">
                                        <a
                                            v-bind:href="`mailto:${team.manager_email}`"
                                        >{{team.manager_email}}</a>
                                    </v-list-tile-content>
                                </v-list-tile>
                                <v-list-tile>
                                    <v-list-tile-content>Phone:</v-list-tile-content>
                                    <v-list-tile-content class="align-end">
                                        <a
                                            v-bind:href="`tel:+1-${team.manager_phone}`"
                                        >{{team.manager_phone}}</a>
                                    </v-list-tile-content>
                                </v-list-tile>
                                <v-list-tile v-if="is_admin()">
                                    <v-list-tile-content>Location:</v-list-tile-content>
                                    <v-list-tile-content class="align-end">
                                        {{
                                        team.location
                                        }}
                                    </v-list-tile-content>
                                </v-list-tile>
                                <v-list-tile v-if="is_admin()">
                                    <v-list-tile-content>Colour:</v-list-tile-content>
                                    <v-list-tile-content class="align-end">
                                        <v-btn
                                            active-class="none"
                                            small
                                            depressed
                                            v-bind:style="setBackgroundColour(team)"
                                            class="mr-0 ml-0"
                                        >{{ team.colour }}</v-btn>
                                    </v-list-tile-content>
                                </v-list-tile>
                            </v-list>
                            <v-divider></v-divider>
                            <v-card-actions>
                                <v-btn
                                    v-if="getTeamRoster(team.id)"
                                    flat
                                    small
                                    color="primary"
                                    v-bind:to="{name: 'rosters_show', params: {id: getTeamRoster(team.id).id}}"
                                >Roster</v-btn>
                                <v-btn
                                    v-else
                                    flat
                                    small
                                    color="primary"
                                    disabled
                                >No Roster</v-btn>
                                <v-btn
                                    v-if="is_admin()"
                                    flat
                                    small
                                    color="warning"
                                    v-bind:to="{name: 'admin_teams_edit', params: {id: team.id}}"
                                >Edit</v-btn>
                                <v-btn
                                    v-if="is_admin()"
                                    flat
                                    small
                                    color="error"
                                    v-on:click="issueDelete(team)"
                                >Delete</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-flex>
                </template>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
import { useWhiteTextHex } from '../utils/colour-utils'

export default {
    name: 'TeamsGrid',
    props: ['admin', 'teams'],
    data() {
        return {
            exact: true
        }
    },
    methods: {
        is_admin() {
            if (this.admin) {
                return true
            } else {
                return false
            }
        },
        issueDelete(team) {
            this.$store.dispatch('deleteTeam', team)
        },
        setBackgroundColour(team) {
            if (useWhiteTextHex(team.colour)) {
                return `background-color: ${team.colour}; color: #ffffff;`
            } else {
                return `background-color: ${team.colour}; color: #000000;`
            }
        },
        getTeamRoster(team_id) {
            if (team_id) {
                return this.$store.getters.getRosterByTeamId(team_id)
            }
        }
    },
    computed: {
        clientPlatform() {
            return this.$store.state.clientPlatform
        }
    }
}
</script>

<style scoped></style>
